<template>
  <div class="subpage main_area" style="position: relative">
    <div class="player_profile player_profiledetails layout">
      <div class="tips_block">温馨提示：信息填写立即绑定。一经绑定不可随意修改。如需修改资料，请联系 24 小时在线客服为您服务。</div>
      <form class="bankcards_add_form" id="bankcards_add_form">
        <input type="hidden" name="player_update" value="1" id="player_update" />
        <div class="block_content">
          <label class="textbox_content">
            <input type="text" v-model="usdtInfo.bank_no" placeholder="请输入USDT地址" oninput="value=value.replace(/[\W]/g,'')" name="account_name" id="account_name" class="fn binput" />
            <div class="input_title"></div>
            <div class="error_msg account_name_error"></div>
          </label>
        </div>
        <div class="block_content">
          <label class="textbox_content">
            <select name="" v-model="usdtInfo.bank_owner" id="" class="fn binput">
              <option :value="null" disabled selected>请选择钱包协议</option>
              <option value="ERC20">ERC20</option>
              <option value="TRC20">TRC20</option>
            </select>
            <div class="input_title"></div>
            <div class="error_msg mobile_number_error"></div>
          </label>
        </div>

        <div class="block_content">
          <label class="textbox_content">
            <input type="password" placeholder="支付密码" v-model="usdtInfo.pay_pass" name="account_number" id="account_number" class="digit ireset binput" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')" />
            <div class="input_title"></div>
            <div class="error_msg account_number_error"></div>
          </label>
        </div>
        <div class="block_content dbreset">
          <input type="hidden" name="default_bank" value="1" />
        </div>
        <div class="block_content" @click="bindUsdss">
          <label class="textbox_content">
            <div class="btn_major add_bank_btn">绑定USDT地址</div>
          </label>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'addUsdtAds',
  data() {
    return { usdtInfo: { bank_owner: 'ERC20' } };
  },
  created() {
    let that = this;
  },
  methods: {
    bindUsdss() {
      let that = this;
      let usdtInfo = that.usdtInfo;
      usdtInfo.bank = 'USDT';
      console.log(usdtInfo);
      if (usdtInfo.bank_no == null || usdtInfo.bank_no == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!usdtInfo.bank_owner && usdtInfo.bank_owner != null) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!usdtInfo.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', usdtInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, res.message);
            this.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mode/addUsdtAds.vue